// File: frontend/src/components/Layout/Layout.tsx
import React, { useState } from 'react';
import { Box, CssBaseline, useMediaQuery, useTheme } from '@mui/material';
import Sidebar from './Sidebar';
import Header from './Header';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleSidebarToggle = () => {
    setMobileOpen((prev) => !prev);
  };

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <Sidebar mobileOpen={mobileOpen} onClose={handleSidebarToggle} />
      <Box
        component="main"
        sx={{ flexGrow: 1, bgcolor: 'background.default', p: { xs: 1.5, sm: 2, md: 3 }, height: '100vh', overflow: 'auto' }}
      >
        <Header onMenuToggle={isMobile ? handleSidebarToggle : undefined} />
        {/* The Toolbar is a spacer to push content below the fixed header */}
        <Box sx={{ mt: { xs: 2, md: 4 } }}>
            {children}
        </Box>
      </Box>
    </Box>
  );
};

export default Layout;
